const SearchSortType = Object.freeze({
  NULLENUM: 0,
  ALERT_NAME: 1,
  SOURCE: 2,
  TRIGGER: 3,
  CLEAR: 4,
  CURRENT: 5,
  ACTION_COUNT: 6,
  TAG: 7,
  DEVICE_NAME: 8,
  MODEL: 9,
  MAC_ADDRESS: 10,
  LAST_MESSAGE: 11,
  FIRMWARE: 12,
  PUSH_STATUS: 13,
  LINK_STATUS: 14,
  SENSOR_NAME: 15,
  SENSOR_TYPE: 16,
  COMPONENT_NAME: 17,
  LAST_RECEIVED: 19,
  DEVICE_TYPE: 20,
  SERIAL_NUMBER: 21,
  ALERT_COUNT: 22,
  DEVICE_ID: 23,
});

export default SearchSortType;
